import {AddSample, AddSampleCallback, AddSampleContractModel} from "@next/eventservice"
import {ShoppingBagApiPost} from "../../api/shoppingbag"

const getBagESB = new AddSample()
const getBagCallbackESB = new AddSampleCallback()

export const SubscribeToShoppingBagAddSample = (siteUrl: string) => {
    getBagESB.subscribe(data => {
        LoadApiData(siteUrl, data)
    })
}

class ShoppingBagAddSampleModel {
    items = ""
    quantity = 0
    modalItemUrl = ""
}

const LoadApiData = (url: string, data: AddSampleContractModel) => {
    const apiModel = new ShoppingBagAddSampleModel()
    apiModel.items = data.items
    apiModel.quantity = data.quantity
    apiModel.modalItemUrl = data.modalItemUrl

    ShoppingBagApiPost(apiModel, `${url}/bag/addSample`, getBagCallbackESB, data.eventId)
}
